import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiper = () => {
  new Swiper('.swiper-about', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    speed: 600,
    grabCursor: true,
    navigation: {
      prevEl: '.btn_about_prev',
      nextEl: '.btn_about_next',
    },
    pagination: {
      el: '.about_pagination',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      1440: {
        slidesPerView: 8,
        spaceBetween: 10,
      },
    },
  });
};

export default swiper;
